import React from "react";
import { Flex } from "@chakra-ui/react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PageHeader } from "components";
import { SETTINGS_TABS } from "duck";
import { CheckIn, Integrations, General } from "./components";

const Settings: React.FC = () => {
  return (
    <Flex flex="1" flexDirection="column" gridGap="24px">
      <PageHeader title="Settings" tabs={SETTINGS_TABS} />

      <Routes>
        <Route path="/general" element={<General />} />
        <Route path="/check-in" element={<CheckIn />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="*" element={<Navigate to="general" />} />
      </Routes>
    </Flex>
  );
};

export default Settings;
